import React from "react";

export default function NotFound() {
  return (
    <div style={{ textAlign: "center", padding: "80px 20px" }}>
      <h1 style={{ fontSize: "72px", margin: 0 }}>Philippines</h1>
     
      
    </div>
  );
}
